import { render, staticRenderFns } from "./back-Button.vue?vue&type=template&id=7b05b23c&scoped=true&"
import script from "./back-Button.vue?vue&type=script&lang=js&"
export * from "./back-Button.vue?vue&type=script&lang=js&"
import style0 from "./back-Button.vue?vue&type=style&index=0&id=7b05b23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b05b23c",
  null
  
)

export default component.exports